import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="relative px-3 sm:px-6 py-3 bg-purple-500 text-white font-black text-sm sm:text-base border-4 border-purple-500 transition-transform hover:translate-x-1 hover:-translate-y-1 h-[44px] sm:h-auto sm:min-h-[44px] w-[44px] sm:w-32 flex items-center justify-center flex-shrink-0"
      title={i18n.language === 'en' ? 'Switch to French' : 'Passer en anglais'}
    >
      <div className="absolute -top-1 -right-1 w-full h-full bg-purple-700 -z-10"></div>
      <span className="hidden sm:inline">{i18n.language === 'en' ? '🇫🇷 FR' : '🇬🇧 EN'}</span>
      <span className="inline sm:hidden">{i18n.language === 'en' ? '🇫🇷' : '🇬🇧'}</span>
    </button>
  );
}
